const FETCH_SDD_MESSAGE = 'fetchSddMessage';
const FETCH_PREFERRED_STORE = 'fetchPreferredStore';
const FETCH_SEARCH_SUGGESTIONS = 'fetchSearchSuggestions';
const FETCH_TRENDING_QUERIES = 'fetchTrendingQueries';
const LOAD_USER = 'loadUser';
const APPLY_SEARCH_TERM = 'applySearchTerm';

const SET_HEADER_DATA = 'setHeaderData';
const SET_SECONDARY_NAVIGATION = 'setSecondaryNavigation';
const SET_TOP_NAVIGATION = 'setTopNavigation';
const SET_ACCOUNT_LINKS = 'setAccountLinks';
const SET_VIEW_TYPE = 'setViewType';
const SET_FOOTER_DATA = 'setFooterData';
const SET_SDD_MESSAGE = 'setSddMessage';
const SET_PREFERRED_STORE = 'setPreferredStore';
const SET_SEARCH_SUGGESTION_DATA = 'setSearchSuggestionData';
const SET_TRENDING_QUERIES = 'setTrendingQueries';
const SET_SEARCH_MODAL_STATE = 'setSearchModalState';
const SET_ATTRS = 'setAttrs';
const SET_SEARCH_VALUE = 'setSearchValue';
const SET_COUNT = 'setCount';
const INCREASE_COUNT = 'increaseCount';
const SET_ACTIVE_OVERLAY_NAME = 'setActiveOverlayName';
const SET_ACTIVE_SEARCH_TRIGGER_ID = 'setActiveSearchTriggerId';
const RESET_OVERLAY = 'resetOverlay';
const SET_TOP_SUGGESTION = 'setTopSuggestion';
const SET_USER_DATA = 'setUserData';
const SET_SKIP_CONTENT_OFFSET = 'setSkipContentOffset';
const SET_REGISTRIES = 'setRegistries';
const SET_FETCH_ERROR = 'setFetchError';
const SET_SLIDEOUT_ID = 'setSlideoutId';
const SET_SHOW_INTERNATIONAL_CONTEXT_FORM = 'setShowInternationalContextForm';
const SET_POPUP_MEDIA_CONTENT = 'setPopupMediaContent';
const SET_SUGGESTION_ENGINE_USED = 'setSuggestionEngineUsed';
const DELETE_HAMBURGER_MENU = 'deleteHamburgerMenu';
const DELETE_DESKTOP_MENU = 'deleteDesktopMenu';
const DELETE_FOOTER_LINKS = 'deleteFooterLinks';

const SETUP_SERVER_SIDE_EXPERIMENTATION = 'setupServerSideExperimentation';
const SETUP_CLIENT_SIDE_EXPERIMENTATION = 'setupClientSideExperimentation';
const SET_EXPERIMENT_ID = 'setExperimentId';
const SET_EXPERIMENT_CLIENT_ID = 'setExperimentClientId';

export {
  SET_EXPERIMENT_ID,
  SET_EXPERIMENT_CLIENT_ID,
  SETUP_SERVER_SIDE_EXPERIMENTATION,
  SETUP_CLIENT_SIDE_EXPERIMENTATION,
  FETCH_SDD_MESSAGE,
  FETCH_PREFERRED_STORE,
  FETCH_SEARCH_SUGGESTIONS,
  FETCH_TRENDING_QUERIES,
  LOAD_USER,
  APPLY_SEARCH_TERM,
  SET_HEADER_DATA,
  SET_SECONDARY_NAVIGATION,
  SET_TOP_NAVIGATION,
  SET_ACCOUNT_LINKS,
  SET_VIEW_TYPE,
  SET_FOOTER_DATA,
  SET_SDD_MESSAGE,
  SET_PREFERRED_STORE,
  SET_SEARCH_SUGGESTION_DATA,
  SET_TRENDING_QUERIES,
  SET_SEARCH_MODAL_STATE,
  SET_ATTRS,
  SET_SEARCH_VALUE,
  SET_COUNT,
  INCREASE_COUNT,
  SET_ACTIVE_OVERLAY_NAME,
  SET_ACTIVE_SEARCH_TRIGGER_ID,
  RESET_OVERLAY,
  SET_TOP_SUGGESTION,
  SET_USER_DATA,
  SET_SKIP_CONTENT_OFFSET,
  SET_REGISTRIES,
  SET_FETCH_ERROR,
  SET_SLIDEOUT_ID,
  SET_SHOW_INTERNATIONAL_CONTEXT_FORM,
  SET_POPUP_MEDIA_CONTENT,
  SET_SUGGESTION_ENGINE_USED,
  DELETE_HAMBURGER_MENU,
  DELETE_DESKTOP_MENU,
  DELETE_FOOTER_LINKS,
};
